import { connectStorageEmulator, getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { app } from "./auth";

const storage = getStorage(app);
let storageConfigured = false;

function truthyEnv(value) {
  return ["1", "true", "yes", "on"].includes(String(value || "").trim().toLowerCase());
}

function isLocalhost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

function configureStorage() {
  if (storageConfigured) return;

  if (isLocalhost() && truthyEnv(process.env.REACT_APP_USE_FIREBASE_EMULATORS)) {
    const host = process.env.REACT_APP_STORAGE_EMULATOR_HOST || "127.0.0.1";
    const port = Number(process.env.REACT_APP_STORAGE_EMULATOR_PORT || 9199);
    connectStorageEmulator(storage, host, port);
  }

  storageConfigured = true;
}

configureStorage();

function sanitizeFileName(name) {
  return String(name || "file")
    .replace(/[^a-zA-Z0-9._-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 120);
}

function fileExtension(name) {
  const clean = String(name || "");
  const idx = clean.lastIndexOf(".");
  return idx >= 0 ? clean.slice(idx).toLowerCase() : "";
}

export async function uploadPartnerIntakeFile({ partnerId, intakeClientId, restaurantIndex, category, file }) {
  const safePartnerId = String(partnerId || "partner").trim();
  const safeCategory = String(category || "misc").trim();
  const safeRestaurantIndex = Number.isInteger(restaurantIndex) && restaurantIndex >= 0 ? restaurantIndex : 0;
  const baseName = sanitizeFileName(file?.name || "upload");
  const ext = fileExtension(baseName);
  const timestamp = Date.now();
  const random = Math.random().toString(16).slice(2, 10);
  const targetName = `${timestamp}-${random}${ext}`;
  const storagePath = `partner-intakes/${safePartnerId}/${intakeClientId}/restaurant-${safeRestaurantIndex}/${safeCategory}/${targetName}`;

  const storageRef = ref(storage, storagePath);
  await uploadBytes(storageRef, file, {
    contentType: file?.type || "application/octet-stream",
    cacheControl: "private, max-age=0, no-cache",
    customMetadata: {
      originalName: baseName,
      category: safeCategory,
      partnerId: safePartnerId,
      restaurantIndex: String(safeRestaurantIndex),
    },
  });

  return {
    name: baseName,
    contentType: file?.type || "application/octet-stream",
    size: Number(file?.size || 0),
    storagePath,
    bucket: storage.app.options.storageBucket || "",
    restaurantIndex: safeRestaurantIndex,
  };
}

export async function getPartnerIntakeDownloadUrl(fileMeta) {
  const storagePath = String(fileMeta?.storagePath || "").trim();
  if (!storagePath) {
    throw new Error("Missing storage path for partner intake file");
  }

  const bucket = String(fileMeta?.bucket || storage.app.options.storageBucket || "").trim();
  const fileRef = bucket
    ? ref(storage, `gs://${bucket}/${storagePath}`)
    : ref(storage, storagePath);

  return getDownloadURL(fileRef);
}
